module.exports = __webpack_public_path__ + "static/media/YF08_3.ffadf18d.jpg";